// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.img-wrapper {
    /* -webkit-clip-path: inset(30px 10px 30px 10px);
    clip-path: inset(30px 10px 30px 10px); */
    max-height: 200px;
    width: 100%;
    object-fit:cover;

}

.container1{
    margin-top: 0px;
    display: flex;
    flex-direction: column;
    padding: 10px 100px; 
    padding-bottom: 2px;
  width: 100%;
  background-color: #fafcfa;
  padding: 4px 0;
  border-radius: 8px;
}

/* NEW: inner wrapper aligned with blog cards */
.content-inner {
  max-width: 900px;     
  width: 100%;
  margin: 0 auto;       
  padding: 0 1rem;      
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

/* search + category row */
.container2 {
  display: flex;
  justify-content: flex-start;   
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  margin-bottom: 0.5rem;
}

/* search input */
.search {
  flex: 1 1;
  min-width: 260px;
  border: 1px solid #085341;
  border-radius: 20px;
  padding: 10px 14px;
  background: white;
}

/* category selector */
.search2 {
  width: 220px;
  border: 1px solid #085341;
  border-radius: 20px;
  display: flex;
  align-items: center;
  padding: 6px 12px;
  background: white;
}
.search2 label {
  margin-right: 8px;
}
.search2 select {
  flex: 1 1;
  height: 100%;
  width: 100%;
  outline: none;
  border: none;
  font-size: 1rem;
}

/* quick filter heading */
.container1-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 0rem;
}
.container1-header h4 {
  margin: 0;
  font-weight: 600;
  font-size: 1.25rem;
}

/* filter buttons */
.filter {
  display: flex;
  justify-content: flex-start;   /* left align */
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 6px;
}

/* .filter{
    display: flex;
    justify-content: center;   
    gap: 8px;
    flex-wrap: wrap;           
    margin-top: 4px;
} */
.filter button {
  border: none;
  background: #f5f5f5;
  border-radius: 16px;
  padding: 6px 10px;
  cursor: pointer;
  transition: background 0.2s ease;
}
.filter button:hover {
  background: #d9f0e6;
}

/* blog posts count */
.error {
  margin-top: 4px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.error .body {
  margin: 0;
  font-size: 0.95rem;
  color: #444;
}

/* blog card container */
.blogcard {
  width: 100%;
  background-color: #fafcfa;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 20px 100px;
}

/* each blog card */
.blogcard1 {
  display: flex;
  gap: 1rem;
  max-width: 900px;
  margin: 0 auto 2rem auto;
  background-color: white;
  padding: 1.5rem;
  border: 1px solid #085341;
  border-radius: 12px;
}

/* responsive adjustments */
@media screen and (max-width: 1024px) {
  .content-inner {
    padding: 0 16px;
    max-width: 100%;
  }
  .search {
    min-width: 0;
    width: 100%;
  }
  .search2 {
    width: 100%;
  }
  .container2 {
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
  }
  .filter {
    gap: 10px;
  }
  .blogcard {
    padding: 20px;
  }
}

.container2 {
    display: flex;
    justify-content: center;   
    align-items: center;
    gap: 20px;
    flex-wrap: wrap;           
    margin-bottom: 1rem;      
}

.container3{
    background-color:#fafcfa;
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 5rem 20rem; 
    gap: 1.5rem;
}

.container3 h2{
    color: green;
}

.container3 p{
    display: flex;
    align-items: center;
    gap: 0.8rem;
    font-size: large;
    font-weight: 500;   
}

.search{
    border: 1px solid #085341;
    border-radius: 20px;
    background-color: white;
    width: 35%;
    
}

.search2 {
    border: 1px solid #085341;
    border-radius: 20px;
    background-color: white;
    width: 22%;
    display: flex;
    align-items: center; 
    padding: 5px;
    justify-content: center;
   
  }
  
  .search2 label {
    margin-right: 5px; 
  }
  
  .search2 select {
    flex: 1 1;
    height: 100%; 
    width: 100%; 
    outline: none;
    border: none;
    font-size: 1rem;
  }

.blogcard{
    width: 100%;
    background-color:#fafcfa;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    padding: 20px 100px; 
   
}


  .blogcard1 {
  display: flex; 
  gap: 2rem;                 
  max-width: 900px;          
  margin: 0 auto 2rem auto;  
  background-color: white;
  padding: 1.5rem;           
  border: 1px solid #085341;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05); /* subtle shadow */
}

  
  .img-container {
  width: 200px;       /* fixed thumbnail width */
  height: 350px;      /* fixed thumbnail height */
  overflow: hidden;
  border-radius: 8px; /* rounded edges  */
  flex-shrink: 0;
}

.img-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;  
}


  .content {
    flex: 1 1; 
    display: flex; 
    flex-direction: column; 
    position: relative;
    /* distribute space */
  } 
  
  .date {
    align-self: flex-start; 
    margin-left: auto; 
  }
  
  .body {
    text-align: justify; 
    padding: 1rem; 
  }

  .body1 {
    text-align: justify; 
    padding: 1rem; 
    font-size: large;
  }
  .body1 ul li{
    list-style: disc;
    font-weight: 400;
  }
  .body1 ol li{
    list-style: decimal;
    font-weight: 400;
  }
  
  .read {
    align-self: flex-end; 
    position: absolute;
    bottom: 0;
  }
  
.read-more-link{
    padding: 8px 15px;
    font-weight: 600;
    border-radius: 10px;
    border: none;
    background-color: white;
    border: 1px solid #085341;
    color: green;
    text-decoration: none;
}

.read-more-link:hover{
    background-color: green;
    color: white;
    border: none;
}

.share-link{
    display: flex;
    justify-content: flex-end;
}


.author{
    font-size: small;
    font-weight: 600;
}

.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.pagination ul {
  list-style: none;
  padding: 0;
  display: flex;
}

.pagination li {
  margin: 0 5px;
}

.pagination a {
  color: #79bead;  
  text-decoration: none;
  padding: 8px 12px;
  border: 1px solid  #79bead;
  border-radius: 5px;
  cursor: pointer;
  /* background-color: #79bead;  */
}

.active {
  /* background-color: #79bead;  */
  color: #79bead; 
  /* border: 1px solid #79bead; */
}

.img-con {
    display: flex; 
    justify-content: center;
    align-items: center;
  }
  
  /* .img-con img {
    width: 100%; 
    height: 50%;
    object-fit: contain; 
    border-radius: inherit; 
  } */

  .img-con img {
  max-width: 700px;   /* limit size */
  max-height: 400px;  /* keep it from being too tall */
  width: 100%;        /* responsive */
  height: auto;       /* keep aspect ratio */
  object-fit: cover;  /* neat cropping */
  border-radius: 10px;
}


.error{
    display: flex;
    align-items: left;
    justify-content: left;
}


@media screen and (max-width: 1024px) {
    .blogcard{
        width: 100%;
        padding: 20px; 
    }
    .blogcard1 {
      flex-direction: column; 
      gap: 1rem; 
    }
    
    .img-container {
      width: 100%; 
      margin-bottom: 1rem; 
    }
    .container1{
        padding: 20px ; 
        margin-top: 20px;
    }
    .container2{
        display: flex;
        flex-direction: column;
    }

    .container3{
        margin-top: 10px;
      padding: 3rem;       
    }
    .search, .search2{
        width: 100%;
    }
    .filter{
        display: grid;
        grid-template-columns: repeat(2, 1fr)
    }
    .body {  
        margin-bottom: 2rem; 
      }
  
  }

 `, "",{"version":3,"sources":["webpack://./src/components/Blogs.css"],"names":[],"mappings":";AACA;IACI;4CACwC;IACxC,iBAAiB;IACjB,WAAW;IACX,gBAAgB;;AAEpB;;AAEA;IAEI,eAAe;IACf,aAAa;IACb,sBAAsB;IAEtB,mBAAmB;IACnB,mBAAmB;EAIrB,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AANpB;;AASA,+CAA+C;AAC/C;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAO;EACP,YAAY;EACZ,WAAW;EACX,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,2BAA2B,IAAI,eAAe;EAC9C,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;;AAEA;;;;;;GAMG;AACH;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;IACf,eAAe;EACjB;EACA;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;EACA;IACE,SAAS;EACX;EACA;IACE,aAAa;EACf;AACF;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;;AAEd;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;;EAEzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,WAAW;IACX,aAAa;IACb,YAAY;IACZ,eAAe;EACjB;;AAEF;IACI,WAAW;IACX,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;;AAEvB;;;EAGE;EACA,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,sCAAsC,EAAE,kBAAkB;AAC5D;;;EAGE;EACA,YAAY,QAAQ,0BAA0B;EAC9C,aAAa,OAAO,2BAA2B;EAC/C,gBAAgB;EAChB,kBAAkB,EAAE,mBAAmB;EACvC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;;EAGE;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;EACX;;AAEF;IACI,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;;AAGA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,cAAc;EACd,+BAA+B;AACjC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;;;;;KAKG;;EAEH;EACA,gBAAgB,IAAI,eAAe;EACnC,iBAAiB,GAAG,gCAAgC;EACpD,WAAW,SAAS,eAAe;EACnC,YAAY,QAAQ,sBAAsB;EAC1C,iBAAiB,GAAG,kBAAkB;EACtC,mBAAmB;AACrB;;;AAGA;IACI,aAAa;IACb,iBAAiB;IACjB,qBAAqB;AACzB;;;AAGA;IACI;QACI,WAAW;QACX,aAAa;IACjB;IACA;MACE,sBAAsB;MACtB,SAAS;IACX;;IAEA;MACE,WAAW;MACX,mBAAmB;IACrB;IACA;QACI,cAAc;QACd,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,gBAAgB;MAClB,aAAa;IACf;IACA;QACI,WAAW;IACf;IACA;QACI,aAAa;QACb;IACJ;IACA;QACI,mBAAmB;MACrB;;EAEJ","sourcesContent":["\n.img-wrapper {\n    /* -webkit-clip-path: inset(30px 10px 30px 10px);\n    clip-path: inset(30px 10px 30px 10px); */\n    max-height: 200px;\n    width: 100%;\n    object-fit:cover;\n\n}\n\n.container1{\n    background-color:#fafcfa;\n    margin-top: 0px;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    padding: 10px 100px; \n    padding-bottom: 2px;\n}\n\n.container1 {\n  width: 100%;\n  background-color: #fafcfa;\n  padding: 4px 0;\n  border-radius: 8px;\n}\n\n/* NEW: inner wrapper aligned with blog cards */\n.content-inner {\n  max-width: 900px;     \n  width: 100%;\n  margin: 0 auto;       \n  padding: 0 1rem;      \n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n/* search + category row */\n.container2 {\n  display: flex;\n  justify-content: flex-start;   \n  align-items: center;\n  gap: 4px;\n  flex-wrap: wrap;\n  margin-bottom: 0.5rem;\n}\n\n/* search input */\n.search {\n  flex: 1;\n  min-width: 260px;\n  border: 1px solid #085341;\n  border-radius: 20px;\n  padding: 10px 14px;\n  background: white;\n}\n\n/* category selector */\n.search2 {\n  width: 220px;\n  border: 1px solid #085341;\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  padding: 6px 12px;\n  background: white;\n}\n.search2 label {\n  margin-right: 8px;\n}\n.search2 select {\n  flex: 1;\n  height: 100%;\n  width: 100%;\n  outline: none;\n  border: none;\n  font-size: 1rem;\n}\n\n/* quick filter heading */\n.container1-header {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-top: 0rem;\n}\n.container1-header h4 {\n  margin: 0;\n  font-weight: 600;\n  font-size: 1.25rem;\n}\n\n/* filter buttons */\n.filter {\n  display: flex;\n  justify-content: flex-start;   /* left align */\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-top: 6px;\n}\n\n/* .filter{\n    display: flex;\n    justify-content: center;   \n    gap: 8px;\n    flex-wrap: wrap;           \n    margin-top: 4px;\n} */\n.filter button {\n  border: none;\n  background: #f5f5f5;\n  border-radius: 16px;\n  padding: 6px 10px;\n  cursor: pointer;\n  transition: background 0.2s ease;\n}\n.filter button:hover {\n  background: #d9f0e6;\n}\n\n/* blog posts count */\n.error {\n  margin-top: 4px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n.error .body {\n  margin: 0;\n  font-size: 0.95rem;\n  color: #444;\n}\n\n/* blog card container */\n.blogcard {\n  width: 100%;\n  background-color: #fafcfa;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n  padding: 20px 100px;\n}\n\n/* each blog card */\n.blogcard1 {\n  display: flex;\n  gap: 1rem;\n  max-width: 900px;\n  margin: 0 auto 2rem auto;\n  background-color: white;\n  padding: 1.5rem;\n  border: 1px solid #085341;\n  border-radius: 12px;\n}\n\n/* responsive adjustments */\n@media screen and (max-width: 1024px) {\n  .content-inner {\n    padding: 0 16px;\n    max-width: 100%;\n  }\n  .search {\n    min-width: 0;\n    width: 100%;\n  }\n  .search2 {\n    width: 100%;\n  }\n  .container2 {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 4px;\n  }\n  .filter {\n    gap: 10px;\n  }\n  .blogcard {\n    padding: 20px;\n  }\n}\n\n.container2 {\n    display: flex;\n    justify-content: center;   \n    align-items: center;\n    gap: 20px;\n    flex-wrap: wrap;           \n    margin-bottom: 1rem;      \n}\n\n.container3{\n    background-color:#fafcfa;\n    margin-top: 20px;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    padding: 5rem 20rem; \n    gap: 1.5rem;\n}\n\n.container3 h2{\n    color: green;\n}\n\n.container3 p{\n    display: flex;\n    align-items: center;\n    gap: 0.8rem;\n    font-size: large;\n    font-weight: 500;   \n}\n\n.search{\n    border: 1px solid #085341;\n    border-radius: 20px;\n    background-color: white;\n    width: 35%;\n    \n}\n\n.search2 {\n    border: 1px solid #085341;\n    border-radius: 20px;\n    background-color: white;\n    width: 22%;\n    display: flex;\n    align-items: center; \n    padding: 5px;\n    justify-content: center;\n   \n  }\n  \n  .search2 label {\n    margin-right: 5px; \n  }\n  \n  .search2 select {\n    flex: 1;\n    height: 100%; \n    width: 100%; \n    outline: none;\n    border: none;\n    font-size: 1rem;\n  }\n\n.blogcard{\n    width: 100%;\n    background-color:#fafcfa;\n    display: flex;\n    flex-direction: column;\n    gap: 1.5rem;\n    padding: 20px 100px; \n   \n}\n\n\n  .blogcard1 {\n  display: flex; \n  gap: 2rem;                 \n  max-width: 900px;          \n  margin: 0 auto 2rem auto;  \n  background-color: white;\n  padding: 1.5rem;           \n  border: 1px solid #085341;\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05); /* subtle shadow */\n}\n\n  \n  .img-container {\n  width: 200px;       /* fixed thumbnail width */\n  height: 350px;      /* fixed thumbnail height */\n  overflow: hidden;\n  border-radius: 8px; /* rounded edges  */\n  flex-shrink: 0;\n}\n\n.img-container img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;  \n}\n\n\n  .content {\n    flex: 1; \n    display: flex; \n    flex-direction: column; \n    position: relative;\n    /* distribute space */\n  } \n  \n  .date {\n    align-self: flex-start; \n    margin-left: auto; \n  }\n  \n  .body {\n    text-align: justify; \n    padding: 1rem; \n  }\n\n  .body1 {\n    text-align: justify; \n    padding: 1rem; \n    font-size: large;\n  }\n  .body1 ul li{\n    list-style: disc;\n    font-weight: 400;\n  }\n  .body1 ol li{\n    list-style: decimal;\n    font-weight: 400;\n  }\n  \n  .read {\n    align-self: flex-end; \n    position: absolute;\n    bottom: 0;\n  }\n  \n.read-more-link{\n    padding: 8px 15px;\n    font-weight: 600;\n    border-radius: 10px;\n    border: none;\n    background-color: white;\n    border: 1px solid #085341;\n    color: green;\n    text-decoration: none;\n}\n\n.read-more-link:hover{\n    background-color: green;\n    color: white;\n    border: none;\n}\n\n.share-link{\n    display: flex;\n    justify-content: flex-end;\n}\n\n\n.author{\n    font-size: small;\n    font-weight: 600;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.pagination ul {\n  list-style: none;\n  padding: 0;\n  display: flex;\n}\n\n.pagination li {\n  margin: 0 5px;\n}\n\n.pagination a {\n  color: #79bead;  \n  text-decoration: none;\n  padding: 8px 12px;\n  border: 1px solid  #79bead;\n  border-radius: 5px;\n  cursor: pointer;\n  /* background-color: #79bead;  */\n}\n\n.active {\n  /* background-color: #79bead;  */\n  color: #79bead; \n  /* border: 1px solid #79bead; */\n}\n\n.img-con {\n    display: flex; \n    justify-content: center;\n    align-items: center;\n  }\n  \n  /* .img-con img {\n    width: 100%; \n    height: 50%;\n    object-fit: contain; \n    border-radius: inherit; \n  } */\n\n  .img-con img {\n  max-width: 700px;   /* limit size */\n  max-height: 400px;  /* keep it from being too tall */\n  width: 100%;        /* responsive */\n  height: auto;       /* keep aspect ratio */\n  object-fit: cover;  /* neat cropping */\n  border-radius: 10px;\n}\n\n\n.error{\n    display: flex;\n    align-items: left;\n    justify-content: left;\n}\n\n\n@media screen and (max-width: 1024px) {\n    .blogcard{\n        width: 100%;\n        padding: 20px; \n    }\n    .blogcard1 {\n      flex-direction: column; \n      gap: 1rem; \n    }\n    \n    .img-container {\n      width: 100%; \n      margin-bottom: 1rem; \n    }\n    .container1{\n        padding: 20px ; \n        margin-top: 20px;\n    }\n    .container2{\n        display: flex;\n        flex-direction: column;\n    }\n\n    .container3{\n        margin-top: 10px;\n      padding: 3rem;       \n    }\n    .search, .search2{\n        width: 100%;\n    }\n    .filter{\n        display: grid;\n        grid-template-columns: repeat(2, 1fr)\n    }\n    .body {  \n        margin-bottom: 2rem; \n      }\n  \n  }\n\n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
